import * as MapVesselUtil from "@/utils/MapVesselUtil";

/**
 * 航跡の速度による色を返す
 * @param velocity 速度
 */
const getVelocityColor = velocity => {
  if (velocity < 10) return "#00FF00"; // 10ktまで
  if (velocity >= 10 && velocity < 20) return "#FFFF00"; // 20ktまで
  return "#FF8000"; // 20kt以上
};

const crateWakeLineFeatureCollection = wakes => {
  let features = [];
  let trackLineList = [];

  wakes.forEach(track => {
    if (trackLineList.length === 0) {
      trackLineList.push(track);
    } else {
      trackLineList.push(track);
      let properties = {
        color: trackLineList[0].color,
        opacity: trackLineList[0].opacity
      };
      let feature = MapVesselUtil.createWakeLineStringFeature(
        trackLineList,
        properties
      );
      features.push(feature);
      trackLineList = [];
      trackLineList.push(track);
    }
  });
  trackLineList = [];

  return MapVesselUtil.createFeatureCollection(features);
};

const crateWakeLineFeature = wakes => {
  let features = [];
  let trackLineList = [];

  wakes.forEach(track => {
    if (trackLineList.length === 0) {
      trackLineList.push(track);
    } else {
      trackLineList.push(track);
      let properties = {
        vesselName: trackLineList[0].vesselName,
        speed: trackLineList[0].v !== null ? trackLineList[0].v.toFixed(1) : "0.0",
        localDate: trackLineList[0].localDate,
        color: trackLineList[0].color,
        opacity: trackLineList[0].opacity
      };
      let feature = MapVesselUtil.createWakeLineStringFeature(
        trackLineList,
        properties
      );
      features.push(feature);
      trackLineList = [];
      trackLineList.push(track);
    }
  });

  return features;
};

export default {
  getVelocityColor,
  crateWakeLineFeature,
  crateWakeLineFeatureCollection
};
